import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+800',
  label: 'Emprendedores confían en el sistema'
}, {
  value: '4.9/5',
  label: 'Valoración promedio'
}, {
  value: '+180',
  label: 'Recursos, plantillas y prompts'
}, {
  value: '#1',
  label: 'Sistema para crear contenido que vende'
}];
export const Stats = () => {
  return <section className="py-8 md:py-12 border-y border-white/5 bg-brand-card/50" data-id="element-162">
      <div className="container px-4 mx-auto max-w-7xl" data-id="element-163">
        <div className="grid grid-cols-2 gap-6 md:gap-8 md:grid-cols-4" data-id="element-164">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center" data-id="element-165">
              <div className="mb-2 text-3xl font-bold md:text-4xl text-brand-gold font-serif" data-id="element-166">
                {stat.value}
              </div>
              <div className="text-sm text-gray-400 md:text-base" data-id="element-167">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};